<template>
  <div class="goodsfreightReduction">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from1"
      @Refresh="Refresh"
      @search="search"
    >
      <template v-slot:right>
       
        <el-button
          @click="onHandleExport"
          type="warning"
          icon="el-icon-upload2"
          :disabled="disabledExport"
          >导出</el-button
        >
      </template>
    </Filtersearch>

    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" width="80" align="center" label="序号">
        </el-table-column>
       
        <el-table-column prop="logistics_name" align="center" label="城市仓">
        </el-table-column>
        <el-table-column prop="business_name" align="center" label="集配中心">
        </el-table-column>
        <el-table-column prop="obj_type_text" align="center" label="减免类型">
        </el-table-column>
     
        <el-table-column prop="discount_object" align="center" label="减免对象">
         
        </el-table-column>
        <el-table-column prop="enabled_member_text" align="center" label="生效用户">
         
        </el-table-column>

       
        <el-table-column prop="start_time_text" align="center" label="生效时间">
          <template slot-scope="scope">
            {{ scope.row.start_time_text }}-{{ scope.row.end_time_text }}
          </template>
        </el-table-column>

        <el-table-column
          prop="discount_text"
          align="center"
          label="折扣
"
        >
        </el-table-column>
        <el-table-column
          prop="status_text"
          align="center"
          label="状态
"
        >
        </el-table-column>
        <el-table-column prop="create_time_text" align="center" label="创建时间">
        </el-table-column>

       
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="50"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <GoodsDetails ref="GoodsDetailsref"></GoodsDetails>

  
  </div>
</template>
<script>
import GoodsDetails from "@/components/GlobalDetails.vue";
import Filtersearch from "@/components/Filtersearch.vue";

export default {
  name: "supplier",
  components: {
    Filtersearch,
    GoodsDetails,
  },
  data() {
    return {
      value1: [],
      loadingselect: false,
      currentPage: 0,
      total: 0,
      loading: false,
      disabledExport: false, // 导出按钮
      tableData: [],
      centerDialogVisible: false,
      Filterdata: "",
      itemobj: "",
     
      from: {
        page: 1, //	T文本	是
        pageSize: 50, //	T文本	是
        logistic_business_id: "", // 可选，集配中心ID（2=高碑店，549=孝感）
        tdc_id: "", // 可选，货号（模糊搜索）
        type: "", // 可选，商品名称（模糊搜索）
        status: "", // 可选，状态（active=生效中，expired=已过期，not_start=未开始）
      },
      from1: "",
      Selectionlist: [],

    

      Filtersearchlist: [
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          filterable: true,
          model: "logistic_business_id",
          placeholder: "请选集配中心",
          label: "name",
          value: "id",
          selectoption: [],
          selectoptionname: "business_list",
        },
     {
          type: "select",
          name: "城市仓",
          clearable: true,
          filterable: true,
          model: "tdc_id",
          placeholder: "请选择城市仓",
          label: "name",
          value: "id",
          selectoptionname: "cityList",
          selectoption: [],
        },
        
        {
          type: "select",
          name: "类型",
          clearable: true,
          model: "type",
          placeholder: "请选类型",
          label: "label",
          value: "value",
          selectoption: [
            {
              label: "运费减免",
              value: "1",
            },
            {
              label: "代采费减免",
              value: "2",
            }
          ],
        },
        {
          type: "select",
          name: "状态",
          clearable: true,
          model: "status",
          placeholder: "请选状态",
          label: "label",
          value: "value",
          selectoption: [
            {
              label: "生效中",
              value: "1",
            },
            {
              label: "已过期",
              value: "2",
            },
            // {
            //   label: "未开始",
            //   value: "3",
            // },
          ],
        },
      ],
    };
  },
  created() {
    this.from1 = JSON.parse(JSON.stringify(this.from));
    this.hqlist();
    this.getsearch();
    this.postAjaxBuyerSelectList();
  },
  watch: {},
  methods: {
      /**
     * 导出逻辑
     */
    async onHandleExport() {
      this.disabledExport = true;
      try {
        const query = {
          ...this.from,
          token: sessionStorage.getItem("token"),
        };
        delete query.page;
        delete query.pageSize;

        this.$api.biexport.discountlistexport(query).then((res) => {
          this.goExportCenter();
        });
      } catch (err) {
        this.$message.error("导出失败了");
        console.log("ajax getAfterSaleNewUnExport err", err);
        console.log("ajax postPurchaseSettleExport err", err);
      } finally {
        this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },

  

    /**
     * 展示详情
     */
    onHandelDetails(row) {
      // this.detailsVisible = true;
      // this.detailsLoading = true;
      this.goodsDetail = {
        ...row,
      };
      // // 模拟loading
      // setTimeout(() => {
      //   this.detailsLoading = false;
      // }, 500);
      this.$refs.GoodsDetailsref.hqlist(this.goodsDetail);
    },
  

    /**
     * 获取业务下拉列
     */
    async postAjaxBuyerSelectList() {
          try {
        const res = await this.$api.Followup.logisticsselect({
          name: "",
          page: 1,
          pageSize: 1000,
        });
        console.log(res, "res");
        // this.cityList = res.data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "cityList"
          ) {
            el.selectoption = [
         
              ...res.data,
            ];
          }
        });
      } catch (error) {
        console.log(error, "logisticsList");
      }
    },

    getsearch() {
      this.$api.ban.searchdata().then((res) => {
        console.log(res, "qqqqewq");
        this.Filterdata = res.data;
        this.Filtersearchlist.forEach((el) => {
          if (
            (el.type == "select" || el.type == "selectlinkage") &&
            el.selectoptionname &&
            el.selectoptionname != "cityList"
          ) {
            // let obj = { [el.value]: "", [el.label]: "全部" };
            el.selectoption = res.data[el.selectoptionname];
          }
        });
      });
    },
    Refresh() {
      this.Filtersearchlist.forEach((el) => {
        if (
          (el.type == "select" || el.type == "selectlinkage") &&
          el.selectoptionname
        ) {
          // let obj = { [el.value]: "", [el.label]: "全部" };
          el.selectoption = this.Filterdata[el.selectoptionname];
        }
      });
      Object.assign(this.$data.from, this.$options.data().from);
      this.from1 = JSON.parse(JSON.stringify(this.from));
      this.hqlist();
    },

    search(e) {
      this.from.page = 1;
      this.currentPage = 1;
      this.from = e;
      this.hqlist();
    },
    hqlist() {
      this.loading = true;
      this.$api.fr.generallogisticsdiscountlist(this.from).then((res) => {
        console.log(res, "获取数据");
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;
      this.from1.pageSize = val;
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.from1.page = val;
      this.currentPage = val;
      this.hqlist();
    },
  },
};
</script>
<style lang="scss">
.goodsfreightReduction {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;
  .contents {
    padding: 0 20px;
    padding-top: 20px;
    box-sizing: border-box;
  }
  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
